import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '@features/product/interfaces/product.interface';
import { ProductService } from '@features/product/services/product.service';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fc-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  @Input() searchQuery = '';
  currentPage: any;
  searchProduct: any = [];
  loading: any;
  onSearch: any;
  productLoading: any;
  interval: any;
  faStar = faStar;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private productService: ProductService,
    private router: Router
  ) {}

  ngOnInit(): void {}
  loadProducts() {
    this.loading = true;
    if (!this.productLoading) {
      this.productLoading = true;
      this.currentPage += 1;
      this.productService
        .searchProducts(30, this.currentPage, this.searchQuery)
        .subscribe(
          (data: any) => {
            data.products.forEach((x: any) => this.searchProduct.push(x));
            this.loading = false;
            this.productLoading = false;
          },
          (error) => {
            this.loading = false;
            this.productLoading = false;
          }
        );
    }
  }
  search() {
    if (this.searchQuery != null && this.searchQuery != '') {
      this.currentPage = 0;
      this.searchProduct = [];
      this.loading = true;
      this.onSearch = true;
      if (isPlatformBrowser(this.platformId)) {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          this.loadProducts();
          clearInterval(this.interval);
        }, 2000);
      }
    } else {
      this.loading = false;
      this.onSearch = false;
    }
  }
  navigateToProduct(product: Product) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/product', product.slug]));
  }
}
